import { Endpoints } from '@/lib/Endpoints';
import { getIsAnonymous } from '@/lib/LocalStorage';
import { applyNativeAttributionPromoCode } from '@/lib/nativeAttributionPromoCode';
import { Requester } from '@/lib/Requester';
import { safeSessionStorage } from '@/lib/safeStorage';
import { WebLink } from '@/lib/WebLinks';
import { GenericResponse } from '@/models/GenericResponse';

export const BANNER_CLAIM_STORAGE_KEY = 'hzc_banner_claim';

export type BannerClaimPayload = {
  id: number;
  url?: string | null;
};

export function isBannerGenerateCode(value: unknown): boolean {
  return value === true || value === 1 || value === '1';
}

export function stashBannerClaim(payload: BannerClaimPayload, returnPath: string): void {
  safeSessionStorage.setItem(BANNER_CLAIM_STORAGE_KEY, JSON.stringify(payload));
  const url = String(payload.url || '').trim();
  const dest = url
    ? (url.startsWith('/') ? url : `/${url}`)
    : returnPath;
  if (dest.startsWith('/') && !dest.startsWith('//')) {
    safeSessionStorage.setItem('hzc_login_dest', dest);
  }
}

export function takeStashedBannerClaim(): BannerClaimPayload | null {
  const raw = safeSessionStorage.getItem(BANNER_CLAIM_STORAGE_KEY);
  if (!raw) return null;
  safeSessionStorage.removeItem(BANNER_CLAIM_STORAGE_KEY);
  try {
    const parsed = JSON.parse(raw) as BannerClaimPayload;
    const id = Number(parsed?.id);
    if (!Number.isFinite(id) || id <= 0) return null;
    return { id, url: parsed.url };
  } catch {
    return null;
  }
}

export function loginUrlForBannerClaim(): string {
  return WebLink.LOGIN;
}

export async function claimBannerPromo(bannerId: number): Promise<string | null> {
  const { data: result } = await Requester.post<GenericResponse<{ status?: boolean; code?: string | null }>>(
    Endpoints.CLAIM_BANNER_PROMO,
    { bannerId },
  );
  const statusCode = Number(result?.meta?.statusCode);
  if (Number.isFinite(statusCode) && statusCode !== 0) {
    const err = new Error(result?.meta?.message || 'Kod alınamadı') as Error & {
      response?: { data: GenericResponse<{ status?: boolean; code?: string | null }> };
    };
    err.response = { data: result };
    throw err;
  }
  const code = String(result?.data?.code || '').trim();
  if (!code) return null;
  applyNativeAttributionPromoCode(code);
  return code;
}

export function needsLoginForBannerClaim(): boolean {
  return getIsAnonymous();
}
